/* eslint-disable prettier/prettier */

// library imports
import * as React from "react";
import { Grid, Link, Stack } from "@mui/material";

// component imports
import CoreTeamCustomerAssociation from "./CoreTeamCustomerAssociation";

import { checkPrivileges } from "../../utils/PrivilegesHelper";
import { getHeaders } from "../../utils/HeaderHelper";

// app setting import
import { AuthenticationContext } from "../../Context";
import { PrivilegesContext } from "../../PrivilegesContext";
import ProviderDetails from "./ProviderDetails";
import PrivilegesEdit from "./PrivilegesEdit";
import PersonIcon from "@mui/icons-material/Person";
import { snakeCaseToTitleCase } from "../../utils/CaseFormatHelper";

interface Props {
  selectedProvider: any;
  chat_icon_with_orange_line: string;
  the_wall_icon_grey: string;
  pencil_grey: string;
  menu_track_src: any;
  setPrivilegesModalOpen: any;
  privilegesModalOpen: boolean;
  user_id: number;
  handleEditingOn: any;
  fetchUserPrivileges: () => void;
}

const ProviderShow: React.FC<Props> = (props: any) => {
  const authenticationSetting = React.useContext(AuthenticationContext);

  const [provider, setPatient] = React.useState<any>(props.selectedProvider);
  const userPrivileges = React.useContext(PrivilegesContext);
  const currentUser = authenticationSetting.currentUser;

  React.useEffect(() => {
    getUserInfo();
  }, [props.selectedProvider]);

  const getUserInfo = () => {
    fetch(`/data_fetching/core_teams/${props.selectedProvider?.id}`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (typeof result.error !== "undefined") {
          console.log(result.error);
        } else {
          setPatient(result);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Grid
      item
      xs={6}
      className="panel-container"
      style={{ marginTop: "85px", backgroundColor: "transparent" }}
    >
      <Grid item xs={12} style={{ marginRight: "30px" }}>
        <Grid container className="panel-show-container">
          <Grid container className="panel-information-container">
            <Grid
              container
              direction="row"
              className="admin-header patient-info"
            >
              <Grid item xs={12} className="box-header">
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  paddingX={3}
                  paddingY={1}
                  alignItems={"center"}
                  display={"flex"}
                >
                  <Grid item>
                    <p className="panel-header">Provider Information</p>
                  </Grid>
                  {checkPrivileges(
                    userPrivileges,
                    "Edit Provider Personal Information"
                  ) && (
                    <span>
                      <Link
                        className="action-icon"
                        href="#"
                        onClick={props.handleEditingOn}
                      >
                        <img
                          src={props.pencil_grey}
                          width="35"
                          alt="Edit Provider"
                          className="action-icon-image"
                          style={{ width: "25px", maxHeight: "25px" }}
                        />
                        <p>Edit</p>
                      </Link>
                    </span>
                  )}
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              className="general-patient-info-container"
              style={{ display: "flex", rowGap: "12px" }}
            >
              <Grid item xs={12} className="info-container">
                <div className="overview-container row">
                  <div className="item-icon-container">
                    <PersonIcon sx={{ color: "#FF890A" }} />
                  </div>
                  <div className="header-text-container">
                    <div className="row">
                      <h4 className="overview-header">
                        {props.selectedProvider?.last_name},{" "}
                        {props.selectedProvider?.first_name}{" "}
                        {props.selectedProvider?.middle_name}
                      </h4>
                      <h4 className="medical_id_text">
                        #NPI: {props.selectedProvider?.provider_npi_number}
                      </h4>
                    </div>
                    <p className="overview-detail">
                      {[
                        props.selectedProvider?.creds,
                        snakeCaseToTitleCase(props.selectedProvider?.career),
                        props.selectedProvider?.mobile_phone_number,
                      ]
                        .filter(Boolean)
                        .map((item, index, arr) => (
                          <span key={index}>
                            {item}
                            {index < arr.length - 1 && (
                              <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                            )}
                          </span>
                        ))}
                    </p>
                  </div>
                </div>
                <div className="divider"></div>
                <ProviderDetails provider={props.selectedProvider} />
              </Grid>

              {(currentUser?.starfield_admin ||
                checkPrivileges(userPrivileges, "Organization Admin")) && (
                <PrivilegesEdit
                  selectedProvider={provider}
                  fetchUserPrivileges={props.fetchUserPrivileges}
                />
              )}

              <CoreTeamCustomerAssociation
                csrfToken={authenticationSetting.csrfToken}
                selectedProvider={props.selectedProvider}
                menu_track_src={props.menu_track_src}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProviderShow;
